// extracted by mini-css-extract-plugin
export default {"badge":"classes_badge__fHocT","inline":"classes_inline__OPhcO","detail":"classes_detail__TotJG","facts":"classes_facts__JEVIi"};